var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"popup",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n  "+_vm._s(_vm.message || _vm.$t('errors.default'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }